import { render, staticRenderFns } from "./achieve_details.vue?vue&type=template&id=b1428538&scoped=true&"
import script from "./achieve_details.vue?vue&type=script&lang=js&"
export * from "./achieve_details.vue?vue&type=script&lang=js&"
import style0 from "./achieve_details.vue?vue&type=style&index=0&id=b1428538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1428538",
  null
  
)

export default component.exports